import { RegExpUtility } from "../../text/RegExpUtility";

export class NavigationKeys
{
  static readonly ArrowDown = "ArrowDown";
  static readonly ArrowLeft = "ArrowLeft";
  static readonly ArrowRight = "ArrowRight";
  static readonly ArrowUp = "ArrowUp";
  static readonly End = "End";
  static readonly Home = "Home";
  static readonly PageDown = "PageDown";
  static readonly PageUp = "PageUp";


  // matcher: static readonly (\w+) = "\w+";
  // replace: NavigationKeys.$1,

  static readonly keys:string[] = 
  [
    NavigationKeys.ArrowDown,
    NavigationKeys.ArrowLeft,
    NavigationKeys.ArrowRight,
    NavigationKeys.ArrowUp,
    NavigationKeys.End,
    NavigationKeys.Home,
    NavigationKeys.PageDown,
    NavigationKeys.PageUp
  ];

  static readonly regex:RegExp = RegExpUtility.createMatcherFromCombiningWords( NavigationKeys.keys, true );
  
  static is( key:string )
  {
    return this.regex.test( key );
  }
}